import tokenList from './token-list';
export const wplToken = (tokenName) => {
    return tokenList[`${tokenName}`];
};
//# sourceMappingURL=get-token.js.map